module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-CN":{"tab":{"all":"所有评论","video":"视频点评"}}}')
  delete Component.options._Ctor
}
